export const DRAFT_RAW_KEYS = ["blocks", "entityMap"];

export const LENGTH = 1;

export const BLANK_HTML = "";

export const UNORDERED_LIST_TYPES = ["square", "disc", "circle"];

export const ORDERED_LIST_TYPES = ["decimal", "lower-alpha", "lower-roman"];

export const DRAFT_TAB_LENGTH = 40;

export const DRAFT_MAX_TAB_LENGTH = 400;

// Toolbar buttons configuration
export const TOOLBAR_INLINE_BUTTONS = [
  {
    id: "bold",
    value: "",
    type: "BOLD",
    icon: "bold",
    activeClass: "custom-bold-active-button",
    toolbarID: "toolbar-bold-button",
    tooltip: "Bold",
  },
  {
    id: "italic",
    value: "",
    type: "ITALIC",
    icon: "italic",
    activeClass: "custom-italic-active-button",
    toolbarID: "toolbar-italic-button",
    tooltip: "Italic",
  },
  {
    id: "underline",
    value: "",
    type: "UNDERLINE",
    icon: "underline",
    activeClass: "custom-underline-active-button",
    toolbarID: "toolbar-underline-button",
    tooltip: "Underline",
  },
];

export const TOOLBAR_LIST_BUTTONS = [
  {
    id: "unordered-list",
    icon: "list-ul",
    type: "unordered-list-1",
    activeClass: "draftJsToolbar__unorderedlist_active__button",
    toolbarID: "toolbar-unordered-list-button",
    tooltip: "Bulleted list",
  },
  {
    id: "ordered-list",
    icon: "list-ol",
    type: "ordered-list-1",
    activeClass: "draftJsToolbar__orderedlist_active__button",
    toolbarID: "toolbar-ordered-list-button",
    tooltip: "Numbered list",
  },
];

export const TOOLBAR_HEADER_BUTTONS = [
  {
    id: "one",
    value: "Normal Text",
    type: "unstyled",
    activeClass: "draftJsToolbar__normaltext_active__button",
    toolbarID: "toolbar-normaltext-button",
    tooltip: "Normal Text",
    fontSize: "14.66px",
  },
  {
    id: "two",
    value: "Header 1",
    type: "header-one",
    activeClass: "draftJsToolbar__headerone_active__button",
    toolbarID: "toolbar-header-one-button",
    tooltip: "Heading one",
    fontSize: "32px",
  },
  {
    id: "three",
    value: "Header 2",
    type: "header-two",
    activeClass: "draftJsToolbar__headerone_active__button",
    toolbarID: "toolbar-header-two-button",
    tooltip: "Heading two",
    fontSize: "24px",
  },
  {
    id: "four",
    value: "Header 3",
    type: "header-three",
    activeClass: "draftJsToolbar__headerthree_active__button",
    toolbarID: "toolbar-header-three-button",
    tooltip: "Heading three",
    fontSize: "18.72px",
  },
  {
    id: "five",
    value: "Header 4",
    type: "header-four",
    activeClass: "draftJsToolbar__headerfour_active__button",
    toolbarID: "toolbar-header-four-button",
    tooltip: "Heading four",
    fontSize: "16px",
  },
];

export const TOOLBAR_ALIGN_BUTTONS = [
  {
    id: "text-align:left",
    icon: "align-left",
    type: "left",
    activeClass: "draftJsToolbar__leftalign_active__button",
    toolbarID: "toolbar-left-align-button",
    tooltip: "Align left",
  },
  {
    id: "text-align:center",
    icon: "align-center",
    type: "center",
    activeClass: "draftJsToolbar__centeralign_active__button",
    toolbarID: "toolbar-center-align-button",
    tooltip: "Align center",
  },
  {
    id: "text-align:right",
    icon: "align-right",
    type: "right",
    activeClass: "draftJsToolbar__rightalign_active__button",
    toolbarID: "toolbar-right-align-button",
    tooltip: "Align right",
  },
  {
    id: "text-align:justify",
    icon: "align-justify",
    type: "justify",
    activeClass: "draftJsToolbar__justifyalign_active__button",
    toolbarID: "toolbar-justify-align-button",
    tooltip: "Justify",
  },
];

export const TOOLBAR_IDENT_BUTTONS = [
  {
    id: "indent",
    icon: "indent",
    type: "indent",
    toolbarID: "toolbar-indent-button",
    tooltip: "Indent more",
  },
  {
    id: "outdent",
    icon: "outdent",
    type: "outdent",
    toolbarID: "toolbar-outdent-button",
    tooltip: "Indent less",
  },
];

export const TOOLBAR_HYPERLINK_BUTTON = [
  {
    id: "link",
    icon: "link",
    type: "link",
    toolbarId: "toolbar-link-button",
    addLinkTooltip: "Add Link",
    modifyLinkTooltip: "Modify Link",
  },
];

export const TOOLBAR_BUTTON_TYPES = {
  // inline button types
  BOLD: "BOLD",
  ITALIC: "ITALIC",
  UNDERLINE: "UNDERLINE",
  // List button types
  ORDERED_LIST: "ordered-list",
  UNORDERED_LIST: "unordered-list",
  // Header button types
  HEADER_ONE: "header-one",
  HEADER_TWO: "header-two",
  HEADER_THREE: "header-three",
  HEADER_FOUR: "header-four",
  // Align button types
  LEFT_ALIGNED: "text-align:left",
  CENTER_ALIGNED: "text-align:center",
  RIGHT_ALIGNED: "text-align:right",
  // Normal Text button type
  NORMAL_TEXT: "unstyled",
};

export const TOOLBAR_LINE_HEIGHT_UNITS = [
  {
    id: "FONTLINEHEIGHT_1.6x",
    toolBarValue: "Default",
    value: "1.6",
    style: "line-height:1.6",
  },
  {
    id: "FONTLINEHEIGHT_0.5x",
    toolBarValue: "0.5x",
    value: "0.5",
    style: "line-height:0.5",
  },
  {
    id: "FONTLINEHEIGHT_1x",
    toolBarValue: "1x",
    value: "1",
    style: "line-height:1",
  },
  {
    id: "FONTLINEHEIGHT_1.15x",
    toolBarValue: "1.15x",
    value: "1.15",
    style: "line-height:1.15",
  },
  {
    id: "FONTLINEHEIGHT_1.5x",
    toolBarValue: "1.5x",
    value: "1.5",
    style: "line-height:1.5",
  },
  {
    id: "FONTLINEHEIGHT_2x",
    toolBarValue: "2x",
    value: "2",
    style: "line-height:2",
  },
];
